


























import Vue from "vue";

// Vue Components
import AgentInfoPropsList from "@/components/PropsLists/AgentInfoPropsList.vue";

// Models
import { AgentInfo } from "@/model/data/agent/AgentInfo";

export default Vue.extend({
    components: {
        AgentInfoPropsList,
    },
    data() {
        return {
            caosBackendDialog: false,
        };
    },
    props: {
        agentInfo: { type: Object as () => AgentInfo, required: true },
        caosBackendAddress: { type: Array, default: undefined },
    },
});
